/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { handleStepBack, setFnolReducerPayload, submitBlingClaim } from '../../../actions/claimSubmitActions';
import { navigateTo } from '../../../actions/navigationActions';
import './Cellphone.css';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import Geocode from "react-geocode";
import { logErrorToDatabase, postToController } from '../../../actions/apiActions';
import { showCellphonePleaseWaitModal } from '../../../actions/modalActions';
import { CELLPHONE_CLAIM_ACCIDENTAL_ID, CELLPHONE_CLAIM_INTENTIONAL_ID } from '../../../constants/products';
import { KEYBOARD_KEY_ARROW_DOWN, KEYBOARD_KEY_ARROW_UP, KEYBOARD_KEY_ESCAPE, KEYBOARD_KEY_ENTER } from '../../../constants/keyboardkeys';
import { SA_COUNTRY_ID_NUMBER } from '../../../constants/internationalization';
import { validateCellphoneNumber } from '../../../constants/validation';

var lat = null
var lng = null

class CellphoneRepairReplace extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            isRepaired: undefined,
            adressSelect: this.props.claimSubmit.adress,
            lat: 0,
            lng: 0,
            contact: this.props.profile.cellphoneNumber,
            contactValidation: true,
            name: this.props.profile.name + " " + this.props.profile.surname,
            stepDisabled: false,
            stepSubmitted: false,
            optionValue: "",
            selectedItem: "",
            searchItems: [],
            repairsRepaired: "",
            reRender: true,
            addressDetail: { province: "", city: "", suburb: "", formatted:"", postalCode: ""}
        };

        this.handleIsRepaired = this.handleIsRepaired.bind(this);
        this.handleStepBack = this.handleStepBack.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.mapReady = this.mapReady.bind(this);
        this.handleAdressChange = this.handleAdressChange.bind(this);
        this.handleAdressSelect = this.handleAdressSelect.bind(this);
        this.updateLatLngAdress = this.updateLatLngAdress.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.autocomplete = this.autocomplete.bind(this);
        this.hanldeKeyup = this.hanldeKeyup.bind(this);
        this.hanldeKeydown = this.hanldeKeydown.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.handleChangeNumbers = this.handleChangeNumbers.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        Geocode.setApiKey("AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8");
    }

    async handleOnChange(e) {
        this.setState({ optionValue: e.target.value });
        if (e.target.value === "repaired") {
            await this.setState({ repairsRepaired: true, searchItems: [] })
        }
        else {
            await this.setState({ repairsRepaired: false, searchItems: [] })
        }
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handleChangeNumbers(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        value = value.replace(/[^0-9]/gi, "");
        await this.setState({ [name]: value })
    }

    async handleStepBack() {
        this.props.dispatchAction(handleStepBack());
    }

    async mapReady(mapProps, map) {
        lat = map.center.lat()
        lng = map.center.lng()
        await this.setState({ lat: lat, lng: lng })
        map.addListener("click", (mapsMouseEvent) => {
            lat = mapsMouseEvent.latLng.toJSON().lat
            lng = mapsMouseEvent.latLng.toJSON().lng
            Geocode.fromLatLng(lat, lng).then(
                (response) => {
                    let  streetNumber, streetName, suburb, city, state, country, postal_code;
                    const address = response.results[0];
                    for (let i = 0; i < address.address_components.length; i++) {
                        for (let j = 0; j < address.address_components[i].types.length; j++) {
                            switch (address.address_components[i].types[j]) {
                                case "street_number":
                                    streetNumber = address.address_components[i].long_name;
                                    break;
                                case "route":
                                    streetName = address.address_components[i].long_name;
                                    break;
                                case "sublocality":
                                    suburb = address.address_components[i].long_name;
                                    break;
                                case "locality":
                                    city = address.address_components[i].long_name;
                                    break;
                                case "administrative_area_level_1":
                                    state = address.address_components[i].long_name;
                                    break;
                                case "country":
                                    country = address.address_components[i].long_name;
                                    break;
                                case "postal_code":
                                    postal_code = address.address_components[i].long_name;
                                    break;
                            }
                        }
                    }

                    let addressDetails = { province: state?.toUpperCase(), city: city?.toUpperCase(), suburb: suburb?.toUpperCase(), formatted: address.formatted_address, postalCode: postal_code?.toUpperCase() };
                    this.setState({ lat: lat, lng: lng, addressSelect: address.formatted_address, addressDetail: addressDetails });
                    this.updateLatLngAdress(lat, lng, address, addressDetails);
                },
                (error) => {
                    logErrorToDatabase(error);
                }
            );
            this.setState({ lat: lat, lng: lng })
        });
    }

    handleAdressChange = address => {
        this.setState({ adressSelect: address });
        if (this.state.stepSubmitted) {
            this.checkStep();
        }
    };

    handleAdressSelect = address =>  {
        let addressDetails = { province: "", city: "", suburb: "", formatted:"", postalCode: ""}
        geocodeByAddress(address)
            .then(async (results) => {
                let latlong = await getLatLng(results[0]);
                let  streetNumber, streetName, suburb, city, state, country, postal_code;
                const address = results[0];
                for (let i = 0; i < address.address_components.length; i++) {
                    for (let j = 0; j < address.address_components[i].types.length; j++) {
                        switch (address.address_components[i].types[j]) {
                            case "street_number":
                                streetNumber = address.address_components[i].long_name;
                                break;
                            case "route":
                                streetName = address.address_components[i].long_name;
                                break;
                            case "sublocality":
                                suburb = address.address_components[i].long_name;
                                break;
                            case "locality":
                                city = address.address_components[i].long_name;
                                break;
                            case "administrative_area_level_1":
                                state = address.address_components[i].long_name;
                                break;
                            case "country":
                                country = address.address_components[i].long_name;
                                break;
                            case "postal_code":
                                postal_code = address.address_components[i].long_name;
                                break;
                        }
                    }
                }
                addressDetails = { province: state?.toUpperCase(), city: city?.toUpperCase(), suburb: suburb?.toUpperCase(), formatted: address.formatted_address, postalCode: postal_code?.toUpperCase()}
                this.setState({ lat: latlong.lat, lng: latlong.lng, addressSelect: address, addressDetail: addressDetails });
                this.updateLatLngAdress(latlong.lat, latlong.lng, address, addressDetails);
            })
            .catch((err) => { logErrorToDatabase("Error retrieving geoCode by Address: " + address + ": " + err) });
    };

    async updateLatLngAdress(Lat, Lng, address, addressDetails) {
        lat = Lat
        lng = Lng
        await this.setState({ lat: Lat, lng: Lng, adressSelect: addressDetails.formatted, addressDetail: addressDetails });
        this.props.dispatchAction(setFnolReducerPayload({ addressLat: Lat, addressLon: Lng, addressDetail: addressDetails }));
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    };

    async handleSubmit() {
        await this.setState({ stepSubmitted: true })
        if (this.state.stepSubmitted) {
            await await this.checkStep();
        }
        if (!this.state.stepDisabled) {
            await this.props.dispatchAction(submitBlingClaim());
        }
    }

    async checkStep() {
        let payload = {}
        await this.setState({ stepDisabled: true })
        await this.setState({ contactValidation: validateCellphoneNumber.test(this.state.contact) });
        if (this.state.isRepaired) {
            if (this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_ACCIDENTAL_ID || this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_INTENTIONAL_ID) {
                if (this.state.repairsRepaired) {
                    if (this.state.isRepaired && this.state.repairsRepaired !== "" && this.state.name && this.state.contact && this.state.contactValidation) {
                        await this.setState({ stepDisabled: false })
                        payload = {
                            hasBeenRepaired: true,
                            isRepaired: this.state.repairsRepaired,
                            contactPersonFullName: this.state.name,
                            contactPersonNumber: this.state.contact,
                        }
                    }
                }
                else {
                    if (this.state.isRepaired !== undefined && this.state.repairsRepaired !== "" && this.state.name && this.state.contact && this.state.contactValidation && this.state.selectedItem && this.state.selectedItem.fullDescription) {
                        await this.setState({ stepDisabled: false })
                        payload = {
                            hasBeenRepaired: true,
                            isRepaired: this.state.repairsRepaired,
                            newDeviceName: this.state.selectedItem.fullDescription,
                            contactPersonFullName: this.state.name,
                            contactPersonNumber: this.state.contact,
                        }
                    }
                }
            }
            else {
                if (this.state.isRepaired && this.state.name && this.state.contact && this.state.contactValidation && this.state.selectedItem && this.state.selectedItem.fullDescription) {
                    await this.setState({ stepDisabled: false })
                    payload = {
                        hasBeenRepaired: true,
                        isRepaired: false,
                        contactPersonFullName: this.state.name,
                        contactPersonNumber: this.state.contact,
                        newDeviceName: this.state.selectedItem.fullDescription,
                    }
                }
            }
        }
        else {
            if (this.state.isRepaired !== undefined && this.state.adressSelect && this.state.name && this.state.contact && this.state.contactValidation) {
                await this.setState({ stepDisabled: false })
                payload = {
                    addressLon: this.state.lng,
                    addressLat: this.state.lat,
                    hasBeenRepaired: false,
                    isRepaired: false,
                    address: this.state.adressSelect,
                    addressDetail: this.state.addressDetail,
                    contactPersonFullName: this.state.name,
                    contactPersonNumber: this.state.contact,
                }
            }
        }
        if (!this.state.stepDisabled) {
            await this.props.dispatchAction(setFnolReducerPayload(payload));
        }
    }

    async handleIsRepaired(isRepaired) {
        await this.setState({ reRender: false })
        if (isRepaired) {
            await this.props.dispatchAction(showCellphonePleaseWaitModal())
            await this.setState({ isRepaired: isRepaired, optionValue: "", repairsRepaired: "", reRender: true, selectedItem: "", searchItems: [] });
        } else {
            await this.setState({ isRepaired: isRepaired, optionValue: "", repairsRepaired: "", reRender: true, selectedItem: "", searchItems: [] });
        }

        if (this.state.stepSubmitted) {
            await this.checkStep();
        }

    }

    handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });

        if (this.state.stepSubmitted) {
            this.checkStep();
        }
    }

    async autocomplete(evt) {
        let text = evt.target.value;
        var listmax = 50;   //Make the search quicker - can't return full list
        var items = [];
        await this.setState({ selectedItem: text });
        await this.setState({ searchItems: [] });

        if (text && text.length >= 3) {
            await postToController(this.props.dispatch, 'CellphoneSearch', JSON.stringify({ SearchText: text, TopNResults: 10 }))
                .then(async (response) => {
                    if (response) {
                        items = response
                            .filter((i, index) => (index < listmax))
                            .map((i, index) => {
                                return (
                                    i
                                );
                            });
                        await this.setState({ searchItems: items });
                    }
                });
        }
    }

    hanldeKeyup(evt) {
        if (evt.keyCode === KEYBOARD_KEY_ESCAPE) {
            this.setState({ searchItems: [] });
            return false;
        }
    }

    hanldeKeydown(evt) {
        // arrow up/down button should select next/previous list element
        if (evt.keyCode === KEYBOARD_KEY_ARROW_UP && this.state.cursor > 0) {
            this.setState(prevState => ({
                cursor: prevState.cursor - 1
            }));
        } else if (evt.keyCode === KEYBOARD_KEY_ARROW_DOWN && this.state.searchItems && this.state.cursor && (this.state.cursor < this.state.searchItems.length - 1)) {
            this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }));
        }
        if (evt.keyCode === KEYBOARD_KEY_ENTER) {
            let currentItem = this.state.searchItems[this.state.cursor];
            if (currentItem !== undefined) {
                this.setState({ searchItems: [] });
            }
        }
    }

    async selectItem(item) {
        await this.setState({ selectedItem: item, replacementValue: item.cellPhoneReplacementValue });
        this.setState({ searchItems: [] });

        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    public render() {
        const countryFilter = this.props.profile.countryId === SA_COUNTRY_ID_NUMBER ? "ZA" : "NA"
        let pleaseNote = <div></div>;
        pleaseNote = <div className="glass-repairs-pleaseNote-container mt-20px">
            <p className="glass-repairs-please-note mb-0px"><b>Please note:</b>
                <br />Keep your receipts and invoice as proof that your cellphone has been replaced/repaired. </p>
        </div>;
        return (
            <div className="col ssp-container-fnol-repairs ssp-container-fnol-step-header-padding">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-ssp-header-fnol-what-happened">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>Repairs/<br className="glassclaims-newline" />Replacement</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 fnol-steps-info-section-holder">
                        <hr className="hr-minus21px" />
                        <div className="row noma cellphoneclaims-parent-row">
                            <div className="col nopa">
                                {(this.props.claimSubmit.incidentType.description === "Accidental damages" || this.props.claimSubmit.incidentType.description === "Intentional damage") && <p className="font-size-16px glassclaims-intro-p mt-10px"><b>Have you already repaired/<br className="glassclaims-newline" />replaced your phone</b></p>}
                                {(this.props.claimSubmit.incidentType.description === "Loss" || this.props.claimSubmit.incidentType.description === "Theft") && <p className="font-size-16px glassclaims-intro-p mt-10px"><b>Have you replaced your phone already?</b></p>}
                            </div>
                            <div className="nopa text-lg-right cellphoneclaims-button-col">
                                <div className="row noma cellphoneclaims-button-row">
                                    <div className="col nopa cellphoneclaims-button-no">
                                        <button className={!this.state.isRepaired && this.state.isRepaired !== undefined ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="isRepairedFalse" onClick={() => this.handleIsRepaired(false)}>No</button>
                                    </div>
                                    <div className="cellphoneclaims-mobile-gutter nopa"></div>
                                    <div className="col nopa cellphoneclaims-button-yes">
                                        <button className={this.state.isRepaired && this.state.isRepaired !== undefined ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="isRepairedTrue" onClick={() => this.handleIsRepaired(true)}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr className="mb-0px mt-20px glassclaims-hr-2px" />
                        {/* Yes journey*/}

                        {this.state.isRepaired && this.state.isRepaired !== undefined &&
                            <>
                                {(this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_ACCIDENTAL_ID || this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_INTENTIONAL_ID) && this.state.reRender &&
                                    <>
                                        <div className="row noma mt-22px">
                                            <div className="col-12 nopa">
                                                <p className="text-16 mb-0px"><b>Select the option that applies to you</b></p>
                                            </div>
                                            <div className="col-12 nopa mt-15px">
                                                <div className="form-check nopa mb-14px">
                                                    <input className="form-check-input radio-custom glassclaims-radio-custom" type="radio" name="radio-group" id="repairsRepaired" value="repaired" onChange={this.handleOnChange} />
                                                    <label className="form-check-label radio-custom-label glassclaims-radio-custom-label" htmlFor="repairsRepaired">
                                                        I’ve already <b>repaired</b> my phone
                                                    </label>
                                                </div>
                                                <div className="form-check nopa">
                                                    <input className="form-check-input radio-custom glassclaims-radio-custom" type="radio" name="radio-group" id="repairsReplaced" value="replaced" onChange={this.handleOnChange} />
                                                    <label className="form-check-label radio-custom-label glassclaims-radio-custom-label" htmlFor="repairsReplaced">
                                                        I’ve already <b>replaced</b> my phone
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="mt-19px mb-0px glassclaims-hr-2px" />
                                    </>
                                }

                                {this.state.optionValue !== "" && this.state.optionValue === "repaired" && (this.props.claimSubmit.incidentType.description === "Accidental damages" || this.props.claimSubmit.incidentType.description === "Intentional damage") && pleaseNote}
                                {this.state.optionValue !== "" && this.state.optionValue === "replaced" && (this.props.claimSubmit.incidentType.description === "Accidental damages" || this.props.claimSubmit.incidentType.description === "Intentional damage") &&
                                    <div>
                                        <div className="ssp-cellphone-details-main-contentholder mt-20px mb-6px ssp-addreplacement-value-p-holder">
                                            <div className="mb-0px font-size-16px font-weight-500 ssp-addreplacement-value-intro-header">
                                                What's your new phone's make and model
                                            </div>
                                        </div>
                                        <div className="form-group mb-20px" id="cellphone-make-and-model">
                                            <input
                                                type="text"
                                                id="autocomplete"
                                                onChange={this.autocomplete}
                                                onKeyUp={this.hanldeKeyup}
                                                onKeyDown={this.hanldeKeydown}
                                                value={this.state.selectedItem.fullDescription}
                                                className="form-control clientName underline pl-0px"
                                                placeholder="Make and model"
                                            />
                                            {this.state.searchItems.length > 0 && (
                                                <ul id="makeAndModel" className="list-group">
                                                    {this.state.searchItems.map((item, idx) => (
                                                        <li
                                                            className={
                                                                this.state.cursor === idx ? "active list-group-item " : "list-group-item"
                                                            }
                                                            key={idx}
                                                            onClick={() => this.selectItem(item)}
                                                        >
                                                            {item.fullDescription}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                        {this.state.selectedItem === "" || this.state.selectedItem === undefined && this.state.stepSubmitted &&
                                            <div className="help-block mt-0">Make and model is required</div>
                                        }
                                        {pleaseNote}
                                        <hr className="mt-19px mb-0px glassclaims-hr-2px" />
                                    </div>
                                }
                                {(this.props.claimSubmit.incidentType.description === "Loss" || this.props.claimSubmit.incidentType.description === "Theft") &&
                                    <div>
                                        <div className="ssp-cellphone-details-main-contentholder mt-20px mb-6px ssp-addreplacement-value-p-holder">
                                            <div className="mb-0px font-size-16px font-weight-500 ssp-addreplacement-value-intro-header">
                                                What's your new phone's make and model
                                            </div>
                                        </div>
                                        <div className="form-group mb-20px" id="cellphone-make-and-model">
                                            <input
                                                type="text"
                                                id="autocomplete"
                                                onChange={this.autocomplete}
                                                onKeyUp={this.hanldeKeyup}
                                                onKeyDown={this.hanldeKeydown}
                                                value={this.state.selectedItem.fullDescription}
                                                className="form-control clientName underline pl-0px"
                                                placeholder="Make and model"
                                            />
                                            {this.state.searchItems.length > 0 && (
                                                <ul id="makeAndModel" className="list-group">
                                                    {this.state.searchItems.map((item, idx) => (
                                                        <li
                                                            className={
                                                                this.state.cursor === idx ? "active list-group-item " : "list-group-item"
                                                            }
                                                            key={idx}
                                                            onClick={() => this.selectItem(item)}
                                                        >
                                                            {item.fullDescription}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                        {this.state.selectedItem === "" || this.state.selectedItem === undefined && this.state.stepSubmitted &&
                                            <div className="help-block mt-0">Make and model is required</div>
                                        }
                                        {pleaseNote}
                                        <hr className="mt-19px mb-0px glassclaims-hr-2px" />
                                    </div>
                                }
                            </>

                        }
                        {!this.state.isRepaired && this.state.isRepaired !== undefined &&
                            <div className="row noma cellphoneclaims-parent-row mt-20px">
                                <div className="col-12 nopa">
                                    <p className="font-size-16px font-weight-bold line-height-normal mb-15px">Pick up/drop off address</p>
                                    <p className="font-weight-normal line-height-normal mb-0px">If your claim's authorised, we'll need to know where to pick up/drop off your phone</p>
                                </div>
                                <div id="GoogleMap" className="col-12 nopa mt-23px">
                                    <div>
                                        <PlacesAutocomplete
                                            value={this.state.adressSelect}
                                            onChange={this.handleAdressChange}
                                            onSelect={this.handleAdressSelect}
                                            searchOptions={{ componentRestrictions: { country: countryFilter } }}
                                        >
                                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                <div className="position-relative">
                                                    <input
                                                        {...getInputProps({
                                                            placeholder: 'Type your pick up/drop off address here...',
                                                            className: ' ssp-autocomplete-searchbox',
                                                        })}
                                                    />
                                                    <div className={(suggestions.length > 0 ? 'ssp-autocomplete-dropdown-container' : 'd-none')}>
                                                        {loading && <div className="ssp-autocomplete-loading">Loading...</div>}
                                                        {suggestions.map(suggestion => {
                                                            const className = 'ssp-autocomplete-suggestion-item';
                                                            return (
                                                                <>
                                                                    <div
                                                                        {...getSuggestionItemProps(suggestion, {
                                                                            className,
                                                                        })}
                                                                    >
                                                                        <span className="ssp-autocomplete-suggestion-actual">{suggestion.description}</span>
                                                                    </div>
                                                                    <div className="ssp-autocomplete-hr-container">
                                                                        <hr className="ssp-autocomplete-hr-divider" />
                                                                    </div>
                                                                </>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            )}
                                        </PlacesAutocomplete>
                                    </div>

                                    <Map google={this.props.google}
                                        centerAroundCurrentLocation
                                        center={{ lat: this.state.lat, lng: this.state.lng }}
                                        onReady={this.mapReady}
                                        containerStyle={{
                                            position: 'relative',
                                            overflow: 'hidden',
                                            width: '100%',
                                            height: '271px',
                                        }}>
                                        <Marker
                                            // @ts-ignore
                                            position={{ lat: this.state.lat, lng: this.state.lng }}
                                            draggable={false}
                                            title="Start typing"
                                        />
                                    </Map>
                                </div>
                            </div>
                        }
                        {this.state.isRepaired !== undefined &&
                            <div className="col-12 nopa mt-20px">
                                {!this.state.isRepaired &&
                                    <p className="font-size-16px font-weight-bold line-height-normal mb-15px">Who should our supplier contact regarding repairs/replacement</p>
                                }
                                {this.state.isRepaired &&
                                    <p className="font-size-16px font-weight-bold line-height-normal mb-15px">We might need to contact you about your claim<br />Please provide your details below</p>
                                }
                                <div className="row noma">
                                    <div className="col-12 nopa mb-20px">
                                        <div className="form-group noma">
                                            <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.name !== "" ? "" : " no-opacity")}>Name</label>
                                            <input type="text" name="name" placeholder="Name" value={this.state.name} className="form-control clientName underline nopa" onChange={this.handleChange} />
                                            {this.state.submitted && !this.state.name && this.state.stepSubmitted &&
                                                <div className="form-inline-error">Name is required</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 nopa">
                                        <div className={'form-group noma' + (this.state.Step1Submitted && !this.state.contact && !this.state.contactValidation ? 'has-error' : '')}>
                                            <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.contact !== "" ? "" : " no-opacity")}>Phone no.</label>
                                        <input type="text" name="contact" placeholder="Phone no." maxLength={10} value={this.state.contact} onChange={this.handleChangeNumbers} className="form-control clientName underline nopa" />
                                            {this.state.Step1Submitted && !this.state.contact &&
                                                <div className="form-inline-error">Contact details are required</div>
                                            }
                                            {this.state.Step1Submitted && !this.state.contactValidation &&
                                                <div className="form-inline-error">Contact details are incorrect</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="nopa fnol-steps-buttonholder mt-40px">
                            <button className="btn btn-solid-red fnol-buttonreverse-button-next glassclaims-button-next" onClick={this.handleSubmit} id="submit" disabled={this.state.stepDisabled}>Next</button>
                            <button className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleStepBack} id="back">Back</button>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchAction: (e) => dispatch(e),
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)(CellphoneRepairReplace);

export default GoogleApiWrapper({
    apiKey: 'AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8'
})(connector);